import { render, staticRenderFns } from "./split-transaction.vue?vue&type=template&id=243ab2e9&scoped=true"
import script from "./split-transaction.vue?vue&type=script&lang=js"
export * from "./split-transaction.vue?vue&type=script&lang=js"
import style0 from "./split-transaction.vue?vue&type=style&index=0&id=243ab2e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ab2e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243ab2e9')) {
      api.createRecord('243ab2e9', component.options)
    } else {
      api.reload('243ab2e9', component.options)
    }
    module.hot.accept("./split-transaction.vue?vue&type=template&id=243ab2e9&scoped=true", function () {
      api.rerender('243ab2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/split-transaction.vue"
export default component.exports